import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'app-checkbox-control',
  standalone: true,
  imports: [ReactiveFormsModule, CheckboxModule],
  templateUrl: './checkbox-control.component.html',
  styleUrl: './checkbox-control.component.scss',

})
export class CheckboxControlComponent {
  @Input() label!: string;
  @Input() control!: FormControl | any;
  @Input() name: string = '';
  @Input() lightMode!: boolean;
  @Input() classess!: string;
  @Input() binary: boolean = false;
  @Input() labelPosition: 'Before' | 'After' = 'Before';
  @Input() value: any;
  @Input() disabled: boolean;

  @Input() count: any;

  @Output() onChangeEvent: EventEmitter<CheckboxChangeEvent> = new EventEmitter<CheckboxChangeEvent>(); 

  public checkboxChanged(event: CheckboxChangeEvent){
    this.onChangeEvent.emit(event);
  }


}
